import React from "react";
import "../styles/courseCard.css"

import Card from "./card"

import qaidaimg from "../assets/images/qaida.png";
// import tajveedimg from "../assets/images/tajveed.jpg";
import tajweedimg from "../assets/images/tajweed.png";
import hifzimage from "../assets/images/hifz.png"

export default function CourseCards() {
    const courseCard = [
        {
            title: "Tajweed ul Quran",
            description: "Learn Quran With Tajweed From Home. When it comes to learning Quran with Tajweed, you should have a professional and experienced Qari to make you proficient in it. Here are a few reasons why Quran Schooling is the best online Quran teaching academy in the US and UK when it comes to an online tajweed course.",
            img: tajweedimg,
            link: "courses/tajweed",
            headingcolor: "#e3c26d"
        },
        // {
        //     title: "Quran Tutors For Tajweed",
        //     description: "Learning Quran Tajweed from a Qari is not easy when they are not experts in it. Quran recitation with Tajweed means to recite and pronounce each letter of the Quran which fulfills the right of that word. For that purpose, you should have a professional Quran Qari to help you with how to read Quran with Tajweed. Teaching tajweed requires a person to have a command over the Arabic language. That is why we only hire those teachers who are experts in the Arabic language and know its grammar in depth. We only hire certified and experienced online Quran tutor to give you online Quran Classes with tajweed.",
        //     img: qaidaimg
        // },
        // {
        //     title: "Number of Tests to Check",
        //     description: "We always recruit the best Quran teachers who help our students to learn Tajweed online. We know that an incompetent teacher can never proficiently teach them to learn Tajwid Quran. To choose the best qari for our students, Quran Schooling has created a series of tests to check the capability of the teacher. Anyone who passes these tests and meets our criteria is selected to help them to learn Tajweed Quran online.",
        //     img: qaidaimg
        // },
        // {
        //     title: "Adaptable Timings For Online Tajweed Lessons",
        //     description: "While going to a madrasa, the main problem a student encounters is its timings. It becomes difficult for a student to follow the strict time table and reach on time every day. It causes a great loss of Tajweed learning for students. But it is no longer a problem because Quran Schooling offers you online tajweed classes, with flexible timings. After registration, you can decide timings for your session according to your own convenience. Having this opportunity makes it easier for the students to schedule the classes according to their availability. In this way, they will no longer miss their online tajweed classes.",
        //     img: qaidaimg
        // },
        {
            title: "Noorani Qaida",
            description: "The satisfaction of our students is the most important thing for Quran Schooling. We take every possible step to satisfy the students with the teachers they are provided with. To maintain this legacy, we take reviews from our students from time to time. We give great importance to these reviews. We judge the performance of our teachers based on the reviews provided by our students. If we come to know that the student is not satisfied with learning Tajweed from a particular teacher, we do replace the teacher.",
            img: qaidaimg,
            link: "courses/qaida",
            headingcolor: "#e3c26d"
        },
        {
            title: "Hifz-ul-Quran",
            description: "When a student goes to a madrasa, chances are that one cannot get proper attention from the teacher due to a large number of students. We understand that it becomes difficult for a student to learn Quran tajwid if there is a lot of disturbance near one. To solve this problem, Quran Schooling offers one to one sessions in online tajweed classes.",
            img: hifzimage,
            link: "courses/hifz",
            headingcolor: "#e3c26d"
        },

    ]
    return (
        <div>
            <div style={{ width: "100%" }}>
                <h1 style={{ color: "black" }}>
                    Courses
                </h1>
            </div>
            <div className="coursescard-container">
                {
                    courseCard.map(card => (
                        <Card img={card.img} title={card.title} description={card.description} key={card.title} link={card.link} color="white" transprent={true} headingcolor={card.headingcolor} />
                    ))
                }
            </div>
        </div>
    );
}

